import { memo } from 'react';

import styles from './PrivacyPolicy.module.css';


const PrivacyPolicy = memo(() => {
  return (
    <div className={styles.cardContent}>

      <div>
        <h3 className={styles.cardTitle}>Introduction</h3>
        <p className={styles.cardDescription}>
          Welcome to HackerGPT by HackerGPT Inc. We are committed to protecting the privacy and security of our customers' sensitive information. This Privacy Policy outlines how we collect, use, and safeguard your data.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Information We Collect</h3>
        <p className={styles.cardDescription}>
          We collect personal information necessary to provide our services. This may include, user prompts, IP addresses, emails of users, subscription information.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Use of Information</h3>
        <p className={styles.cardDescription}>
          Your information is used solely for the purpose of providing and improving our services. We do not share your information with third parties under any circumstances.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Security Measures</h3>
        <p className={styles.cardDescription}>
          We implement multiple security controls to protect your data, including:
        </p>
        <ul className={styles.cardList}>
          <li>Encryption: All sensitive data is encrypted both in transit and at rest.</li>
          <li>Access Controls: Strict access controls are in place to ensure only authorized personnel can access your information.</li>
          <li>Monitoring: Continuous monitoring of our systems to detect and prevent unauthorized access.</li>
          <li>Regular Audits: Regular security audits and assessments to maintain the highest security standards.</li>
        </ul>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Your Rights</h3>
        <p className={styles.cardDescription}>
          You have the right to access your information at any time. Please contact us if you wish to exercise these rights.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Deletion of Prompts</h3>
        <p className={styles.cardDescription}>
          Deletion of previous prompt messages is a feature available to HackerGPT Lite Subscribers. Deletion is irreversible, the information is not possible to recover after deletion. If you are a EU Citizen, we will delete your information without charge after confirming your citizenship and identity.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Deletion of Images</h3>
        <p className={styles.cardDescription}>
          All images uploaded to our platform will be automatically deleted within 30 minutes of image upload. Face Search results pictures will be automatically deleted within 30 minutes as well.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Changes to This Policy</h3>
        <p className={styles.cardDescription}>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we encourage you to review it regularly.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Dispute Resolution; Arbitration; Class Action Waiver; FAA Governing Law</h3>
        <h4>Governing Law – Federal Arbitration Act</h4>
        <p className={styles.cardDescription}>
          This arbitration agreement is governed by and shall be interpreted and enforced in accordance with the Federal Arbitration Act, 9 U.S.C. §§ 1–16 (“FAA”), and not by any state arbitration law. The parties expressly acknowledge that this agreement evidences a transaction involving interstate commerce.
        </p>
        <h4>Mandatory Individual Arbitration</h4>
        <p className={styles.cardDescription}>
          Any dispute, controversy, or claim arising out of or relating to the use of the HackerGPT product, this Privacy Policy, the Terms of Service, or any dealings with HackerGPT Inc. whatsoever (collectively, “Disputes”) shall be resolved exclusively by final and binding arbitration, administered in New York City, New York, by JAMS or the American Arbitration Association (AAA) in accordance with its applicable arbitration rules then in effect, except as modified by this agreement.
        </p>
        <p className={styles.cardDescription}>
          Arbitration shall be conducted by a single neutral arbitrator. The arbitrator shall apply applicable federal law and, where applicable, New York substantive law, consistent with the FAA.
        </p>
        <h4>Class Action Waiver</h4>
        <p className={styles.cardDescription}>
          To the fullest extent permitted by law, all Disputes must be brought on an individual basis only, and not as a plaintiff or class member in any purported class, collective, consolidated, representative, or private attorney general proceeding.
        </p>
        <p className={styles.cardDescription}>
          You and HackerGPT Inc. expressly waive any right to participate in or bring:
        </p>
        <ul className={styles.cardList}>
          <li>class actions,</li>
          <li>class arbitrations,</li>
          <li>collective actions,</li>
          <li>representative actions, or</li>
          <li>private attorney general actions.</li>
        </ul>
        <p className={styles.cardDescription}>
          The arbitrator shall have no authority to consolidate claims, conduct class or representative proceedings, or award relief to anyone other than the individual party seeking relief.
        </p>
        <p className={styles.cardDescription}>
          This waiver is an essential term of this arbitration agreement and is intended to be enforced consistent with Epic Systems Corp. v. Lewis, 138 S. Ct. 1612 (2018), and AT&T Mobility LLC v. Concepcion, 563 U.S. 333 (2011).
        </p>
        <h4>30-Day Arbitration Opt-Out Right</h4>
        <p className={styles.cardDescription}>
          You may opt out of this arbitration agreement within thirty (30) days of first accepting this Privacy Policy or first using the HackerGPT product, whichever occurs first.
        </p>
        <p className={styles.cardDescription}>
          To opt out, you must send a written notice stating your intent to opt out of arbitration to:
        </p>
        <p className={styles.cardDescription}>
          Email: support@hackergpt.app
        </p>
        <p className={styles.cardDescription}>
          Subject Line: “Arbitration Opt-Out”
        </p>
        <p className={styles.cardDescription}>
          The notice must include:
        </p>
        <ul className={styles.cardList}>
          <li>your full name,</li>
          <li>the email address associated with your account, and</li>
          <li>a clear statement that you are opting out of arbitration.</li>
        </ul>
        <p className={styles.cardDescription}>
          Opting out of arbitration will not affect your access to or use of the HackerGPT product, but it will waive your ability to resolve disputes through arbitration.
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Contact Us</h3>
        <p className={styles.cardDescription}>
          If you have any questions or concerns about this Privacy Policy, please contact us at support@hackergpt.app
        </p>
      </div>

      <div>
        <h3 className={styles.cardTitle}>Conclusion</h3>
        <p className={styles.cardDescription}>
          Your privacy is our top priority. We are ensuring that your information is protected and stays strictly between you and us.
        </p>
      </div>

    </div>
  )
});

export default PrivacyPolicy;